import { statusBadgeConfig } from "../descriptions/statusBadge.description";
import useI18N from "../hooks/useI18N";
import { MUIStyled } from "./MUIStyled";
import MUITooltip from "./MUITooltip";
import SAStack from "./SAStack";
import SATypography from "./SATypography";

const StyledBadge = MUIStyled(SAStack)(({ color, background, tooltip }) => ({
  gap: 4,
  color,
  borderRadius: 16,
  backgroundColor: background,
  padding: "2px 8px",
  width: "fit-content",
  textTransform: "capitalize",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "row",
  "& svg": { height: 16, width: 16 },
  ...(tooltip
    ? {
        cursor: "pointer",
        textDecoration: "underline dashed",
        textUnderlineOffset: 3,
        "&:hover": { textDecoration: "none" },
      }
    : {}),
}));

const SAStatusBadge = ({ status, tooltip = false, title = "" }) => {
  const { t } = useI18N();
  const { icon, color, background, label } = statusBadgeConfig[status] || {};

  const Badge = (
    <StyledBadge {...{ color, background, tooltip }}>
      {icon}
      <SATypography fontSize="14px" fontWeight={500}>
        {t(label)}
      </SATypography>
    </StyledBadge>
  );

  return tooltip ? (
    <MUITooltip title={title || t(status)}>{Badge}</MUITooltip>
  ) : (
    Badge
  );
};

export default SAStatusBadge;
